(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/arena-react/assets/react/pages/teams/teams-history.js') >= 0) return;  svs.modules.push('/modules/arena-react/assets/react/pages/teams/teams-history.js');
'use strict';

const {
  TransactionHistoryNoTeams,
  TransactionHistoryList
} = svs.arena.pages.teams.components;
const {
  Select,
  Option,
  ControlGroup
} = svs.ui.ReactForm;
const {
  useTeams
} = svs.arena.shared.hooks;
const TeamsHistory = () => {
  const {
    data: teamsList
  } = useTeams(60);
  const [selectedTeam, setSelectedTeam] = React.useState('-1');
  React.useEffect(() => {
    if (teamsList.length === 1) {
      setSelectedTeam(teamsList[0].syndicateId);
    }
  }, [teamsList]);
  return React.createElement("div", {
    className: "transaction-history-container padding-xs-1 padding-sm-2"
  }, teamsList && teamsList.length === 0 && React.createElement(TransactionHistoryNoTeams, null), teamsList && teamsList.length === 1 && React.createElement("div", {
    className: "f-content margin-bottom-1 padding-left-1"
  }, teamsList[0].syndicateName), teamsList && teamsList.length > 1 && React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    className: "margin-bottom-1",
    onChange: e => setSelectedTeam(e.currentTarget.value),
    v2: true,
    value: selectedTeam
  }, React.createElement(Option, {
    disabled: true,
    key: -1,
    value: "-1"
  }, "V\xE4lj ett lag"), teamsList && teamsList.map(item => {
    var _item$syndicateId;
    return React.createElement(Option, {
      key: item.syndicateId,
      value: (_item$syndicateId = item.syndicateId) === null || _item$syndicateId === void 0 ? void 0 : _item$syndicateId.toString()
    }, item.syndicateName);
  }))), selectedTeam > 0 && React.createElement(TransactionHistoryList, {
    selectedTeam: selectedTeam
  }));
};
svs.arena.pages.teams.TeamsHistory = TeamsHistory;

 })(window);